import FittedNetworkAdView from "../fitted_network_ad_view.tsx/fitted_network_ad_view";

export default function FittedCoupangLineAdView() {
  return <FittedNetworkAdView isCoupangAd />;
}
